import { Box, Skeleton } from "@mui/material";

export const LoadingSkeleton = () => (
  <Box display="flex" flexDirection="column" gap={5}>
    <Skeleton height={24} width={200} variant="rounded" />
    <Skeleton height={60} width="100%" variant="rounded" />
    <Skeleton height={24} width={300} variant="rounded" />
    <Skeleton height={300} width="100%" variant="rounded" />
    <Skeleton height={60} width="100%" variant="rounded" />
  </Box>
);
